import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const ET_TZ = 'America/New_York';

export class DateHelper {
  static getTodayInEasternTime(): Dayjs {
    const nyDateString = dayjs().tz(ET_TZ).format('YYYY-MM-DD');
    return dayjs(nyDateString);
  }

  static getTomorrowInEasternTime(): Dayjs {
    const nyDateString = dayjs().tz(ET_TZ).add(1, 'day').format('YYYY-MM-DD');
    return dayjs(nyDateString);
  }

  static getDateInEasternTime(daysOffset: number): Dayjs {
    const nyDateString = dayjs()
      .tz(ET_TZ)
      .add(daysOffset, 'day')
      .format('YYYY-MM-DD');
    return dayjs(nyDateString);
  }
}
